export default "__VITE_ASSET__CocYjnFr__"